import supportCodesByKey from "./regionalSupportCodes.json";

/**
 * Returns the machine-readable regional backend error code when available.
 *
 * @param {unknown} error - Thrown backend client error.
 * @returns {string | null} Backend error code or null when unavailable.
 */
export function getRegionalBackendErrorCode(error) {
  if (typeof error?.body?.error?.code === "string") {
    return error.body.error.code;
  }

  if (typeof error?.code === "string") {
    return error.code;
  }

  return null;
}

/**
 * Maps a backend or UI error key onto the short patient-facing support code.
 *
 * @param {string | null | undefined} key - Backend error code or UI error key.
 * @returns {string} Stable support code for contact with pDx Support.
 */
export function getRegionalSupportCode(key) {
  if (typeof key === "string" && supportCodesByKey[key]) {
    return supportCodesByKey[key];
  }

  return supportCodesByKey.DEFAULT;
}

/**
 * Resolves the support code for a backend error, with a caller-provided
 * fallback when no backend code is available.
 *
 * @param {unknown} error - Thrown backend client error.
 * @param {string} [fallbackKey="DEFAULT"] - Fallback map key.
 * @returns {{ errorCode: string | null, supportCode: string }} Support metadata.
 */
export function getRegionalBackendSupportMetadata(
  error,
  fallbackKey = "DEFAULT",
) {
  const errorCode = getRegionalBackendErrorCode(error);

  return {
    errorCode,
    supportCode: getRegionalSupportCode(errorCode || fallbackKey),
  };
}
